import { createHashRouter, Outlet, redirect } from 'react-router-dom';
import { HomePage } from 'src/modules/home/HomePage.tsx';
import { ErrorBoundary } from 'src/modules/common/components/ErrorBoundary/ErrorBoundary';
import { PrefetchUserInputKind } from 'src/modules/user-input/PrefetchUserInputKind.tsx';
import { ValvesPage } from 'src/modules/valves/ValvesPage.tsx';
import { ActuatorsPage } from 'src/modules/actuators/ActuatorsPage.tsx';
import { PrefetchAccessories } from 'src/modules/accessories/PrefetchAccessories';
import { PrefetchValvesCheckout } from 'src/modules/checkout/PrefetchValvesCheckout.tsx';
import { SharePage } from 'src/modules/SharePage.tsx';
import { PATHS } from 'src/types/Paths';
import { createChildrenRoute } from 'src/projects/createChildrenRoute.tsx';
import { RouteObject } from 'react-router/dist/lib/context';
import { PageLegacy } from 'src/modules/common/PageLegacy.tsx';

const errorElement = <ErrorBoundary/>;

export const ValveRoutes: RouteObject[] = [
    {
        path: PATHS.Home,
        errorElement,
        element: <HomePage/>,
    },
    {
        path: PATHS.UserInput,
        errorElement,
        element: <PrefetchUserInputKind/>,
    },
    {
        path: `${PATHS.Valves}/:page`,
        errorElement,
        element: <PageLegacy pathname={PATHS.Valves}/>,
    },
    {
        path: `${PATHS.Valves}`,
        errorElement,
        element: <ValvesPage/>,
    },
    {
        path: `${PATHS.Actuators}/:valveLabel/:page`,
        errorElement,
        element: <PageLegacy pathname={PATHS.Actuators}/>,
    },
    {
        path: `${PATHS.Actuators}`,
        errorElement,
        element: <ActuatorsPage/>,
    },
    {
        path: `${PATHS.Accessories}/:valveLabel/:actuatorLabel/:page`,
        errorElement,
        element: <PageLegacy pathname={PATHS.Accessories}/>,
    },
    {
        path: `${PATHS.Accessories}`,
        errorElement,
        element: <PrefetchAccessories/>,
    },
    {
        path: `${PATHS.Checkout}/:valveLabel/:actuatorLabel/:page`,
        errorElement,
        element: <PageLegacy pathname={PATHS.Checkout}/>,
    },
    {
        path: `${PATHS.Checkout}`,
        errorElement,
        element: <PrefetchValvesCheckout/>,
    },
];

export const router = () => createHashRouter([
    {
        path: '/',
        loader: () => redirect(PATHS.Home),
    },
    ...ValveRoutes.map((route) => ({
        ...route,
        element: <Outlet/>,
        children: createChildrenRoute(route.element),
    } as RouteObject)),
    {
        path: PATHS.Share,
        element: <SharePage/>,
        errorElement,
    },
    {
        path: '*',
        loader: () => redirect(PATHS.Home),
    },
]);
